import { SET_LOCAL_STORAGE_LOADED, SET_LOGIN_DATA, SET_LOGIN_EXCHANGE_RATES, SET_LOGIN_FAILED, SET_LOGIN_INVALID_INDEX_ERROR, SET_LOGIN_INVALID_PASSWORD_ERROR, SET_LOGIN_LOADING, SET_LOGIN_USER, SET_PROVIDED_CREDENTIALS, SET_REACT_APP_VERSION } from '../../actionTypes'

const initialState = {
	email: null,
	companyIndex: null,
	user: null,
	exchangeRates: null,
	loginRequested: false,
	loading: false,
	invalidPasswordError: false,
	invalidIndexError: false,
	reactAppVersion: null,
	localStorageLoaded: false,
	providedCredentials: null,
}

export function loginReducer (state = initialState, action) {
	switch (action.type) {
		case SET_LOGIN_DATA:
			return {
				...state,
				email: action.payload.content.email ? action.payload.content.email : state.email,
				companyIndex: action.payload.content.companyIndex?.toUpperCase(),
			}
		case SET_LOGIN_FAILED:
			return {
				...state,
				loginRequested: true,
			}
		case SET_LOGIN_INVALID_PASSWORD_ERROR:
			return {
				...state,
				invalidPasswordError: action.value,
			}
		case SET_LOGIN_INVALID_INDEX_ERROR:
			return {
				...state,
				invalidIndexError: action.value,
			}
		case SET_LOGIN_LOADING:
			return {
				...state,
				loading: action.value,
			}
		case SET_LOGIN_USER:
			return {
				...state,
				user: action.payload.content,
			}
		case SET_LOGIN_EXCHANGE_RATES:
			return {
				...state,
				exchangeRates: action.value,
			}
		case SET_REACT_APP_VERSION:
			return {
				...state,
				reactAppVersion: action.value,
			}
		case SET_LOCAL_STORAGE_LOADED:
			return {
				...state,
				localStorageLoaded: action.value,
			}
		case SET_PROVIDED_CREDENTIALS:
			return {
				...state,
				providedCredentials: action.value,
			}
		default:
			return state
	}
}
